import React from 'react'
import { MediaFromResponse } from '../../models/from-api-response/media'
import { BsMusicNoteBeamed, BsFillPlayFill } from 'react-icons/bs'
import {
	SambaVideosContentCardContainer,
	SambaVideosContentDuration,
	SambaVideosContentTextContent,
	SambaVideosContentThumb,
	SambaVideosContentThumbContainer,
	SambaVideosContentTitle,
} from './style'
import convertSecondsToTimeText from '../../helpers/seconds-to-time-text'

interface SambaVideosContentCardProps {
	content: MediaFromResponse
	onClick: (content: MediaFromResponse) => void
}

const SambaVideosContentCard: React.FC<SambaVideosContentCardProps> = ({ content, onClick }) => {
	const thumbUrl =
		content?.assets?.thumbnail ||
		(content && content.thumbs && content.thumbs.length
			? content.thumbs.sort((thumbA, thumbB) => (thumbA.width > thumbB.width ? -1 : 1))[0].url
			: '')

	const legacyMaxSizedFile =
		content &&
		content.files &&
		content.files.length &&
		content.files.sort((fileA, fileB) => (fileA.fileSize > fileB.fileSize ? -1 : 1))[0]

	const durationInSeconds =
		typeof content?.source?.duration === 'number'
			? content.source.duration
			: legacyMaxSizedFile && legacyMaxSizedFile.fileInfo
			? legacyMaxSizedFile.fileInfo.duration / 1000
			: undefined

	const isVideo =
		(content?.assets && !!content.assets.player) ||
		(legacyMaxSizedFile && legacyMaxSizedFile.qualifier === 'VIDEO')

	return (
		<SambaVideosContentCardContainer onClick={() => onClick(content)}>
			<SambaVideosContentThumbContainer>
				{thumbUrl ? (
					<SambaVideosContentThumb src={thumbUrl} />
				) : isVideo ? (
					<BsFillPlayFill size={32} />
				) : (
					<BsMusicNoteBeamed size={32} />
				)}
			</SambaVideosContentThumbContainer>
			<SambaVideosContentTextContent>
				<SambaVideosContentTitle>{content.title}</SambaVideosContentTitle>
				<SambaVideosContentDuration>
					{typeof durationInSeconds === 'number' && convertSecondsToTimeText(durationInSeconds)}
				</SambaVideosContentDuration>
			</SambaVideosContentTextContent>
		</SambaVideosContentCardContainer>
	)
}

export default SambaVideosContentCard
